import { Link, useLocation } from "react-router";
import { Home, List, Calendar, CalendarDays, Lightbulb } from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  { href: "/", label: "Home", icon: Home },
  { href: "/blocks", label: "Blocks", icon: List },
  { href: "/weekly", label: "Weekly", icon: Calendar },
  { href: "/monthly", label: "Monthly", icon: CalendarDays },
  { href: "/insights", label: "Insights", icon: Lightbulb },
];

export function Footer() {
  const location = useLocation();

  return (
    <footer className="hidden sm:block border-t bg-muted/50">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <div className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} FlexTrack
        </div>
        <div className="flex items-center gap-4">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  "flex items-center gap-1 text-sm",
                  isActive
                    ? "text-primary font-medium"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                <Icon className="h-4 w-4" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </footer>
  );
}
